import { graphql } from '@/graphql-setup'

export const HIDE_WEIRD_ACTIVITY_NOTIFICATION = graphql(`
  mutation HideWeirdActivityNotifications(
    $userId: ID!
    $timestampGte: DateTime!
    $timestampLt: DateTime!
  ) {
    hideWeirdActivityNotifications(
      user: $userId
      timestampStart: $timestampGte
      timestampEnd: $timestampLt
    ) {
      ok
    }
  }
`)
